import { DISPLAY_SCALE } from "../decimal/scales";
import { getNumericValue, resolveFallback } from "./formatterUtils";
import { formatWithThousandsSeparator } from "./formatWithThousandsSeparator";

type FormatCurrencyOptions = {
  fallback?: string;
  showFallback?: boolean;
  showZeros?: boolean;
  symbol?: boolean;
};

export function formatCurrency(value?: number | string | null, options: FormatCurrencyOptions = {}): string {
  const { fallback = "--", showFallback = true, showZeros = false, symbol = true } = options;

  const numericValue = getNumericValue(value);
  if (numericValue === null) {
    return resolveFallback({
      fallback,
      showFallback,
      showZeros,
      zeroValue: symbol ? `AED ${Number(0).toFixed(DISPLAY_SCALE)}` : `${Number(0).toFixed(DISPLAY_SCALE)}`,
    });
  }

  const formattedNumber = formatWithThousandsSeparator(Math.abs(numericValue), { scale: DISPLAY_SCALE });

  const sign = numericValue < 0 ? "-" : "";

  return symbol ? `AED ${sign}${formattedNumber}` : `${sign}${formattedNumber}`;
}
